// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function() {

// ギャラリースライダー（TOP）
  if (document.querySelector('.js-gallery-slider')) {
    const swiper = new Swiper('.js-gallery-slider', {
      speed: 20000, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1.2,
      spaceBetween: 15,
      // centeredSlides: true,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        569: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });
  }

// メンバースライダー（TOP、社員インタビュー詳細）
  if (document.querySelector('.js-member-slider')) {
    const swiper = new Swiper('.js-member-slider', {
      autoplay: {
        delay: 5000,    // スライド表示時間
        disableOnInteraction: false
      },
      loop: true,	// ループ表示
      speed: 500,    // スライド変化時間
      slidesPerView: 1.2, // 表示スライド数
      spaceBetween: 20,   // スライド間の余白
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
      breakpoints: {
        // when window width is >= 320px
        // 415: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 20
        // },
        // when window width is >= 480px
        569: {
          slidesPerView: 2.2,
          spaceBetween: 20
        },
        // when window width is >= 640px
        769: {
          slidesPerView: 3.5,
          spaceBetween: 20
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      }
    });
  }


// スライダー（EDUCATION & WELFARE）
  if (document.querySelector('.js-info-slider')) {
    const swiper = new Swiper('.js-info-slider', {
      autoplay: {
        delay: 5000,    // スライド表示時間
        disableOnInteraction: false
      },
      loop: true,	// ループ表示
      speed: 500,    // スライド変化時間
      slidesPerView: 1.2, // 表示スライド数
      spaceBetween: 20,   // スライド間の余白
      centeredSlides: true,    // 現在スライドを中央に配置する（初期値: false）
      breakpoints: {
        // when window width is >= 320px
        // 415: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 20
        // },
        // when window width is >= 480px
        569: {
          slidesPerView: 1.8,
          spaceBetween: 20
        },
        // when window width is >= 640px
        769: {
          slidesPerView: 3.2,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      pagination: {   // ページネーションの設定
        el: '.swiper-pagination',   // ページネーションラッパーのクラス
        type: 'bullets',   // ドットナビゲーション
        clickable: true,   // クリックしてスライド変更（初期値：false）
      }
    });
  }

  // swiper PC3つ並び / TB2つ並び / SP1つ
  // const swiper = new Swiper(".js-swiper .swiper", {
  //   speed: 1000,
  //   loop: true,
  //   autoplay: {
  //     delay: 2000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   spaceBetween: 0,

  //   // ブレークポイント（画面幅による設定）
  //   breakpoints: {
  //     // 画面幅が 768px 以上の場合（window width >= 768px）
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 20
  //     },
  //     // 画面幅が 1024px 以上の場合（window width >= 1024px）
  //     1024: {
  //       slidesPerView: 3,
  //       spaceBetween: 40
  //     }
  //   },
  //   pagination: {
  //     el: ".js-swiper .swiper-pagination",
  //   },
  //   navigation: {
  //     nextEl: ".js-swiper .swiper-button-next",
  //     prevEl: ".js-swiper .swiper-button-prev",
  //   },
  // });


  // // swiper 自動再生
  // const swiper = new Swiper(".js-swiper .swiper", {
  //   loop: true,
  //   speed: 5000,
  //   autoplay: {
  //     delay: 0,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1.5,
  //   spaceBetween: 10,

  //   // ブレークポイント（画面幅による設定）
  //   breakpoints: {
  //     // 画面幅が 768px 以上の場合（window width >= 768px）
  //     768: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20
  //     },
  //     // 画面幅が 1024px 以上の場合（window width >= 1024px）
  //     1024: {
  //       slidesPerView: 3.5,
  //       spaceBetween: 30
  //     }
  //   },
  // });


  // // swiper サムネイルと連動するスライダー
  // // サムネイル
  // const swiper_thumb = new Swiper('.js-swiper__thumb', {
  //   slidesPerView: 4,
  //   spaceBetween: 30,
  //   freeMode: true,
  //   slideToClickedSlide: true,
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  // })

  // // メインスライダー
  // const swiper_main = new Swiper('.js-swiper__main', {
  //   speed: 1000,
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   loop: true,
  //   loopedSlides: 6,
  //   centeredSlides: true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-swiper .swiper-button-next',
  //     prevEl: '.js-swiper .swiper-button-prev',
  //   },
  //   thumbs: {
  //     swiper: swiper_thumb,
  //   },
  // })

  // スライドの複製
  // swiper専用メソッド（swiper起動前に実行）
  function amplifySledes(slider, num) {
    const slides = slider.querySelectorAll('.swiper-slide');
    if (slides.length < num) {
      const cloneArray = [];
      slides.forEach(slide => {
          cloneArray.push(slide.cloneNode(true));
      });
      const loopCount = Math.floor(num / slides.length);
      const wrapper = slider.querySelector('.swiper-wrapper');
      for (let i = 0; i < loopCount; i++) {
        for (let clone of cloneArray) {
          wrapper.append(clone);
        }
      }
    }
  }
})